import React from "react";
import html2canvas from "html2canvas";
import Box from '@mui/material/Box';
import { useReactToPrint } from "react-to-print";

const PrintPurchaseOrder = "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/Images/CommonImages/Print.png";



const PagePrint = React.memo(({ pageref }) => {

  const handlePrint = useReactToPrint({
    isPrintOn: true,
    content: () => pageref.current,
  });

  const handlePrintClick = () => {
    const confirmed = window.confirm(
      "Do you want to download this? Please choose 'Save as PDF' in the printer dialog to download."
    );
    if (confirmed) {
      handlePrint();
    }
  };

  return <Box
    component="img"
    src={PrintPurchaseOrder}
    sx={{ width: "22px", height: "auto", cursor: "pointer" }}
    onClick={handlePrintClick}
  />
});

export default PagePrint;


